/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import type {HttpMethod} from '@app/lib/HttpTypes';

export interface ApiResponseDetail {
	requestMethod: HttpMethod;
	endpoint: string;
	successful: boolean;
	statusCode: number;
	payload?: unknown;
	rawText?: string;
	responseHeaders?: Record<string, string>;
}

function redactEndpoint(path: string): string {
	let index = 0;
	return path.replace(/\/(\d{5,})/g, () => {
		return `/:id${index++}`;
	});
}

export class ApiResponseError extends Error {
	readonly requestMethod: HttpMethod;
	readonly endpoint: string;
	readonly successful: boolean;
	readonly statusCode?: number;
	readonly payload?: unknown;
	readonly rawText?: string;
	readonly responseHeaders?: Record<string, string>;

	constructor(detail: ApiResponseDetail) {
		super(`[${detail.statusCode}] ${detail.requestMethod.toUpperCase()} ${redactEndpoint(detail.endpoint)}`);
		this.name = 'ApiResponseError';
		this.requestMethod = detail.requestMethod;
		this.endpoint = detail.endpoint;
		this.successful = detail.successful;
		this.statusCode = detail.statusCode;
		this.payload = detail.payload;
		this.rawText = detail.rawText;
		this.responseHeaders = detail.responseHeaders;
	}
}
